import { render, staticRenderFns } from "./ImportClientSegment.vue?vue&type=template&id=f367d0e4&"
import script from "./ImportClientSegment.vue?vue&type=script&lang=js&"
export * from "./ImportClientSegment.vue?vue&type=script&lang=js&"
import style0 from "./ImportClientSegment.vue?vue&type=style&index=0&id=f367d0e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports